import * as React from "react";
import {Types}    from "@Common/types";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load}             from "@Common/react/load";
import {UseState}         from "@Common/react/use-state";
import {SearchableSelect} from "@Common/ui-components/searchable-select/searchable-select";
import {sortMulti}        from "@Common/utils/collections";
import {chain}            from "@Common/utils/fs";
import {equalDeep, omit}  from "@Common/utils/objects";

import './userSearchField.scss';


export const UserSearchField = ({ labelname, value, xdQAType, xdQAValue, data, contentGroup, displayGroup }) => cs(

    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("userLevels"),
    consumeContext("company"),

    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["managing", (_, next) => UseState({next})],
    ["forcedbranchId", ({session}, next) => next( (
        session.value.branchId
    ))],
    ["state", ({session}, next) => UseState({
        defaultValue: session.value,
        next,
    })],
    ["agentList", ({ apis}, next) => {
        return Load({
            fetch: () => apis.next.getAgentList("", 0, 0),
            next,
        });
    }],

    ({state, session, isInternalUser, agentList, forcedbranchId}) => {

       return(
        <div className="user-search-field-g23">
            <div className="form">
                { (
                    <div className="form-group">

                        {SearchableSelect({
                            getSublabel: (agent) => (<>
                                <div>
                                    {[
                                        agent.agentNameLast,
                                        agent.agentNameFirst,
                                        agent.idAgent,
                                        agent.agentLinkId,
                                        agent.agentEmail,
                                    ].filter(Boolean).join(", ")}
                                </div>
                                <div
                                    xd-qa-type="dropdown_item"
                                    xd-qa-name={`Agent ${agent.idAgent}`}
                                >
                                    {agent.agentNameLast} {isInternalUser && `| Internal ID: ${agent.idAgent}`}
                                </div>
                            </>),
                            list: chain(
                                agentList ?? (session.data.agentNameLast ? [{idAgent: session.value.idAgent, agentNameLast: session.data.agentNameLast}] : []),
                                (_) => sortMulti(_, [
                                    (agent) => agent["agentNameLast"]?.toLowerCase(),
                                ]),
                            ),
                            loading: !agentList,
                            placeholder: "Search for an agent",
                            getLabel: (agent) => chain(
                                agent.agentNameLast || agent.agentLinkId,
                                (label) => <span title={label} xd-qa-type="dropdown_item" xd-qa-name={`Office ${label}`}>{label}</span>
                            ),
                            mapSearchAsItemFilter: (search:string) => {
                                const searchLowercase = search.toLowerCase();
                                return (agent) => (isInternalUser && agent.idAgent.includes(searchLowercase)) || [
                                    "agentNameLast",
                                    "agentLinkId",
                                    "agentNameFirst",
                                    "idAgent",
                                    "agentEmail",
                                ].some(field => agent[field].toLowerCase().includes(searchLowercase))
                            },
                            onSelect: async (agent) => {
                                let agentLabelsValuesMap = {
                                    "{{agent:agent_display_1}}": agent.agentDisplay1,
                                    "{{agent:agent_display_2}}": agent.agentDisplay2,
                                    "{{agent:agent_display_3}}": agent.agentDisplay3,
                                    "{{agent:agent_display_4}}": agent.agentDisplay4,
                                    "{{agent:agent_display_5}}": agent.agentDisplay5,
                                    "{{agent:agent_display_6}}": agent.agentDisplay6,
                                    "{{agent:agent_display_7}}": agent.agentDisplay7,
                                    "{{agent:agent_display_8}}": agent.agentDisplay8,
                                    "{{agent:license_number}}":agent.licenseNumber,
                                }

                                let countAgentSearchFields = 0;

                                // Check if there are multiple office search fiels in the template
                                for (const field of data) {
                                    if (field.idDisplayStyle === 8) {
                                        countAgentSearchFields++;
                                    }
                                }

                                //  changing values of other fields based on binding
                                for (const label in agentLabelsValuesMap) {
                                    if (countAgentSearchFields > 1) {
                                        data.find(field => (field.defaultValue === label && field.contentGroup === contentGroup && field.displayGroup === displayGroup))?.onChange(agentLabelsValuesMap[label]);
                                    }
                                    else {
                                        data.find(field => (field.defaultValue === label && field.contentGroup === contentGroup))?.onChange(agentLabelsValuesMap[label]);
                                    }
                                }
                                // update the user search field
                                data.find(field => (field.idDisplayStyle === 8))?.onChange(agent.idAgent);
                                state.onChange(!agent ? {} : {
                                    idAgent: agent.idAgent,
                                });

                            },
                            isSelected: (agent) => value === agent.idAgent,

                            className: "office",
                            searchLabel: "Search an Agent",
                            xdQaName: "agent",
                            scrollCloses: false,
                        })}
                    </div>
                )}

            </div>


            {!equalDeep(
                {
                    ...state.value,
                    ...forcedbranchId,
                },
                session.value
            )}
        </div>
       )
    }

);